export const formatDataUpdatedAt = (value?: string | null) => {
    if (!value) return undefined
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return undefined
    return new Intl.DateTimeFormat('cs-CZ', {
        timeZone: 'Europe/Prague',
    }).format(date)
}
